import React from 'react';
import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';
import cn from 'classnames';
import CardAttachments from '../../../../CardAttachments/CardAttachments';
import { CardButton } from '../../../../Card';
import { ReactComponent as AddFileIcon } from '../../../../../resource/AddFileIcon.svg';
import { actions as newDocumentActions } from '../../../../../actions/new-wdocument.actions';
import deleteWarrantyDocs from '../../../../../requests/deleteWarrantyDocs';
import getWarrantyDocsFile from '../../../../../requests/getWarrantyDocsFile';
import { getBlobUrl } from '../../../../../helpers/getBlobUrl';
import styles from './WarrantyDocs.module.scss';

const pageSize = 2;
const notWarrantyId = 0;

const WarrantyDocs = ({ request, warrantyInfo = {}, canChangeWarranty }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { data: warrantyDocs, isFetching: isWarrantyDocsFetching } =
    queryClient.getQueryState([`warrantyDocs`, request.id]) || {};

  const deleteDocumentMutation = useMutation(
    ({ docId }) => deleteWarrantyDocs(docId),
    {
      onSuccess: () =>
        queryClient.invalidateQueries([`warrantyDocs`, request.id]),
    }
  );

  const handleAddDocumentClick = () => {
    const orgId = warrantyInfo.orgId;

    dispatch(newDocumentActions.openNewDocumentModal(request.id, orgId));
  };

  const handleDeleteDocument = (attachment) => {
    deleteDocumentMutation.mutate({ docId: attachment.id });
  };

  const getAttachmentUrl = async (data) => {
    const attachment = await getWarrantyDocsFile(data.id);

    const url = getBlobUrl(attachment, data.extension);

    return url;
  };

  return (
    <>
      <CardAttachments
        rootClassName={cn(styles.root, {
          [styles.single]: request.garantyId === notWarrantyId,
        })}
        title="Документы по гарантии"
        paginationClassName={styles.pagination}
        showMetaData
        pageSize={pageSize}
        showUpload={false}
        loading={isWarrantyDocsFetching}
        attachments={warrantyDocs}
        onDeleteAttachment={
          canChangeWarranty ? handleDeleteDocument : undefined
        }
        getAttachmentUrl={getAttachmentUrl}
      />
      {canChangeWarranty && (
        <CardButton
          className={styles.button}
          block
          text="Прикрепить файл"
          icon={<AddFileIcon />}
          onClick={handleAddDocumentClick}
        />
      )}
    </>
  );
};

export default WarrantyDocs;
